import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import translations from './translations';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Button from '@material-ui/core/Button';
import FormDrawer from '../FormDrawer';
import PaymentMethodForm from '../PaymentMethodForm';
import Property from '../Property';

const PaymentMethodFormSection = ({ clientId, setPaymentMethod, paymentMethod }) => {
  const intl = useIntl();
  const [showPaymentMethodDrawer, setShowPaymentMethodDrawer] = useState(false);

  const handleSubmit = paymentMethodData => {
    setPaymentMethod({
      method: paymentMethodData?.method ?? null,
      issuer: paymentMethodData?.issuer ?? null,
      provider: paymentMethodData?.provider ?? null,
    });
    setShowPaymentMethodDrawer(false);
  };

  return (
    <>
      <Card style={{ marginBottom: 8 }}>
        <CardHeader
          title={intl.formatMessage(translations.title)}
          titleTypographyProps={{ variant: 'h6' }}
          action={
            <Button
              color="primary"
              variant="outlined"
              onClick={() => setShowPaymentMethodDrawer(true)}
            >
              {intl.formatMessage(translations.buttons.edit)}
            </Button>
          }
        />
        <CardContent>
          <Property
            label={intl.formatMessage(translations.properties.paymentMethod)}
            value={
              paymentMethod?.method?.name
                ? intl.formatMessage({
                    id: `paymentMethods.${paymentMethod?.provider?.toLowerCase()}.${
                      paymentMethod?.method?.code
                    }`,
                    defaultMessage: paymentMethod?.method?.name,
                    description: `label of the payment method for code ${paymentMethod?.method?.code}`,
                  })
                : null
            }
          />
          {paymentMethod?.issuer?.code && (
            <Property
              label={intl.formatMessage(translations.properties.paymentMethodIssuer)}
              value={paymentMethod?.issuer?.name}
            />
          )}
          <Property
            label={intl.formatMessage(translations.properties.paymentProvider)}
            value={
              paymentMethod?.provider
                ? intl.formatMessage({
                    id: `paymentMethods.providers.${paymentMethod?.provider?.toLowerCase()}`,
                    defaultMessage: paymentMethod?.provider,
                    description: `label of the payment provider ${paymentMethod?.provider}`,
                  })
                : null
            }
          />
        </CardContent>
      </Card>
      <FormDrawer
        title={intl.formatMessage(translations.drawer.title)}
        isOpen={showPaymentMethodDrawer}
        onClose={() => setShowPaymentMethodDrawer(false)}
        drawerWidth="400px"
      >
        <PaymentMethodForm
          clientId={clientId}
          paymentMethod={paymentMethod}
          onCancel={() => setShowPaymentMethodDrawer(false)}
          onSubmit={handleSubmit}
        />
      </FormDrawer>
    </>
  );
};

PaymentMethodFormSection.propTypes = {
  clientId: PropTypes.string,
  paymentMethod: PropTypes.object,
  setPaymentMethod: PropTypes.func,
};

PaymentMethodFormSection.defaultProps = {
  clientId: null,
  paymentMethod: null,
  setPaymentMethod: undefined,
};

export default PaymentMethodFormSection;
